import { useState } from "react";
import "./Deck.css";
import Footer from "../Components/Footer/Footer";

export default function FlashcardInterface({ deckData, title }) {
  const [index, setIndex] = useState(0);
  const [flip, setFlip] = useState(false);//false = front showing
  const [disableFlipAnim, setDisableFlipAnim] = useState(false);


  const card = deckData[index];
  
  function nextCard() {
    setDisableFlipAnim(true);//disable animation
    setIndex((prev) => (prev + 1) % deckData.length);
    setFlip(true);//ensure front side
    setTimeout(() => setDisableFlipAnim(false), 50);//re-enable animation quickly
  }

  function prevCard() {
    setDisableFlipAnim(true);
    setIndex((prev) => (prev - 1 + deckData.length) % deckData.length);
    setFlip(true);
    setTimeout(() => setDisableFlipAnim(false), 50);
  }


  return (
    <div>
      <h2 className="deckTitle">{title}</h2>
      <div className="card-container-fc">
        <div className="outerDiv-fc">
          {
          /* Card flip area */}
          <div className="card-fc" onClick={() => setFlip(!flip)}>
            {/* <div className={`card-inner ${flip ? "flipped" : ""}`}> */}
            <div className={`card-inner ${flip ? "" : "flipped"} ${disableFlipAnim ? "no-anim" : ""}`}>
              <div className="card-face front-fc">
                <div className="korean-fc">{card.korean}</div>
              </div>
              <div className="card-face back-fc">
                <div className="english-fc">{card.english}</div>
                {card.description && (
                  <div className="description-fc">{card.description}</div>
                )}
              </div>
            </div>
          </div>
          <div className="controls">
            <button onClick={prevCard}>Previous</button>
            <button id="NextButton" onClick={nextCard}>
              Next
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
